import React from "react";
import { Link } from "react-router-dom";

function Sales() {
  return (
    <div className="py-10">
      <div className="w-full h-full flex items-center justify-center py-10">
        <h1 className="text-5xl text-black font-bold  ">
          <span className=" text-[#e6f060] ">Buy </span> Vegetables
        </h1>
      </div>
      {/* <div className="relative py-10 ">
        <img
          className="w-full h-48 rounded-lg bg-black"
          src="https://thumbs.dreamstime.com/b/seamless-horizontal-pattern-colorful-vegetables-fruits-isolated-white-background-165484658.jpg"
          alt=""
        />
        <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
          <h1 className="text-5xl text-white font-bold bg-black/60 opacity-70 rounded-md ">
            Locally Grown Vegetables for Sale
          </h1>
        </div>
      </div> */}
      <div className="grid grid-cols-4 ">
        <Link to="/buy">
          {" "}
          <div className="shadow-lg rounded-lg flex flex-col items-center  h-80 mr-5">
            <img src="/tam.jpg" className="w-full rounded-md h-32" />
            <h1 className="font-bold text-xl mt-5">Tamatoes</h1>
            <p className="text-sm px-5 mt-2">
              Medium-sized fruit are round, red, meaty and loaded with flavor
            </p>
            <div className="px-5 py-2 rounded-lg bg-[#e6f060]  mt-5 font-semibold text-xl">
              Buy
            </div>
          </div>
        </Link>
        <Link to="/buy">
          {" "}
          <div className="shadow-lg rounded-lg flex flex-col items-center   h-80  mr-5">
            <img
              src="https://static.toiimg.com/thumb/msid-92775530,width-1070,height-580,imgsize-147380,resizemode-6,overlay-toi_sw,pt-32,y_pad-40/photo.jpg"
              className="w-full rounded-md h-32 "
            />
            <h1 className="font-bold text-xl mt-5">Onion</h1>
            <p className="text-sm px-5 mt-2">
              Medium-sized fruit are round, red, meaty and loaded with flavor
            </p>
            <div className="px-5 py-2 rounded-lg bg-yellow-200 mt-5 font-semibold text-xl">
              Buy
            </div>
          </div>
        </Link>
        <Link to="/buy">
          {" "}
          <div className="shadow-lg rounded-lg flex flex-col items-center  h-80  mr-5">
            <img src="/pot.jpg" className="w-full rounded-md h-32" />
            <h1 className="font-bold text-xl mt-5">Potato</h1>
            <p className="text-sm px-5 mt-2">
              Medium-sized fruit are round, red, meaty and loaded with flavor
            </p>
            <div className="px-5 py-2 rounded-lg bg-yellow-200 mt-5 font-semibold text-xl">
              Buy
            </div>
          </div>
        </Link>
        <Link to="/buy">
          {" "}
          <div className="shadow-lg rounded-lg flex flex-col items-center  h-80  mr-5">
            <img src="/spice.jpg" className="w-full rounded-md h-32" />
            <h1 className="font-bold text-xl mt-5">Spices</h1>
            <p className="text-sm px-5 mt-2">
              Medium-sized fruit are round, red, meaty and loaded with flavor
            </p>
            <div className="px-5 py-2 rounded-lg bg-yellow-200 mt-5 font-semibold text-xl">
              Buy
            </div>
          </div>
        </Link>
      </div>
      <div className="grid grid-cols-4  mt-5">
        <Link to="/buy">
          {" "}
          <div className="shadow-lg rounded-lg flex flex-col items-center  h-80 mr-5">
            <img src="/tam.jpg" className="w-full rounded-md h-32" />
            <h1 className="font-bold text-xl mt-5">Tamatoes</h1>
            <p className="text-sm px-5 mt-2">
              Medium-sized fruit are round, red, meaty and loaded with flavor
            </p>
            <div className="px-5 py-2 rounded-lg bg-[#e6f060]  mt-5 font-semibold text-xl">
              Buy
            </div>
          </div>
        </Link>
        <Link to="/buy">
          {" "}
          <div className="shadow-lg rounded-lg flex flex-col items-center   h-80  mr-5">
            <img
              src="https://static.toiimg.com/thumb/msid-92775530,width-1070,height-580,imgsize-147380,resizemode-6,overlay-toi_sw,pt-32,y_pad-40/photo.jpg"
              className="w-full rounded-md h-32 "
            />
            <h1 className="font-bold text-xl mt-5">Onion</h1>
            <p className="text-sm px-5 mt-2">
              Medium-sized fruit are round, red, meaty and loaded with flavor
            </p>
            <div className="px-5 py-2 rounded-lg bg-yellow-200 mt-5 font-semibold text-xl">
              Buy
            </div>
          </div>
        </Link>
        <Link to="/buy">
          {" "}
          <div className="shadow-lg rounded-lg flex flex-col items-center  h-80  mr-5">
            <img src="/pot.jpg" className="w-full rounded-md h-32" />
            <h1 className="font-bold text-xl mt-5">Potato</h1>
            <p className="text-sm px-5 mt-2">
              Medium-sized fruit are round, red, meaty and loaded with flavor
            </p>
            <div className="px-5 py-2 rounded-lg bg-yellow-200 mt-5 font-semibold text-xl">
              Buy
            </div>
          </div>
        </Link>
        <Link to="/buy">
          {" "}
          <div className="shadow-lg rounded-lg flex flex-col items-center  h-80  mr-5">
            <img src="/spice.jpg" className="w-full rounded-md h-32" />
            <h1 className="font-bold text-xl mt-5">Spices</h1>
            <p className="text-sm px-5 mt-2">
              Medium-sized fruit are round, red, meaty and loaded with flavor
            </p>
            <div className="px-5 py-2 rounded-lg bg-yellow-200 mt-5 font-semibold text-xl">
              Buy
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
}

export default Sales;
